import { Controller } from "stimulus";

export default class extends Controller {
    initialize() {
        import(/* webpackChunkName: "shared-favourites" */ '../components/SharedFavourites').then(module => {
            // console.log(this.element, module);
            module.default(this.element, { });
        })
    }
}